module.exports = __webpack_public_path__ + "img/328.e071d2fb.jpg";